export default __webpack_public_path__ + "static/media/auth_exit.e0db523a.svg";